import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "../../i18n/LanguageContext";

// Appears once the visitor is past the hero, hides again near the contact
// section so it never covers the thing it is pointing at.
const StickyCTA = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const contact = document.getElementById("contact");
      const nearContact = contact
        ? contact.getBoundingClientRect().top < window.innerHeight
        : false;
      setVisible(y > 900 && !nearContact);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && !dismissed && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="pointer-events-none fixed inset-x-0 bottom-5 z-50 flex justify-center px-4"
        >
          <div className="pointer-events-auto flex items-center gap-3 rounded-full border border-[rgba(255,255,255,0.12)] bg-[rgba(12,11,24,0.88)] py-2 pl-4 pr-2 shadow-[0_8px_32px_-8px_rgba(0,0,0,0.8)] backdrop-blur-xl">
            <span className="relative flex h-2 w-2 shrink-0">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[rgb(10,190,90)] opacity-70" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-[rgb(10,190,90)]" />
            </span>
            <span className="hidden whitespace-nowrap text-sm text-[rgba(245,245,245,0.8)] sm:inline">
              {t.sticky.available}
            </span>
            <a
              href="mailto:azatesser@gmail.com"
              className="whitespace-nowrap rounded-full bg-[rgb(116,56,255)] px-4 py-2 text-sm font-semibold text-white transition-colors duration-300 hover:bg-[rgb(132,79,255)]"
            >
              {t.sticky.cta}
            </a>
            <button
              onClick={() => setDismissed(true)}
              aria-label={t.sticky.dismiss}
              className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-lg leading-none text-[rgba(245,245,245,0.4)] transition-colors hover:bg-[rgba(255,255,255,0.08)] hover:text-white"
            >
              ×
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCTA;
